import Vue from 'vue';
import Router from 'vue-router';
const Home = () => import( /* webpackChunkName: "Home" */ '@/components/pages/Home');
const Dogs = () => import( /* webpackChunkName: "Dogs" */ '@/components/pages/Dogs');

Vue.use(Router);

export default new Router({
    base: '/',
    mode: 'history',
    linkExactActiveClass: 'is-active',
    routes: [{
        path: '/',
        name: 'home',
        component: Home,
        children: [{
            path: '/pension-canine',
            name: 'pension-canine'
        }, {
            path: '/elevage',
            name: 'elevage'
        }, {
            path: '/activities',
            name: 'activities'
        }]
    }, {
        path: '/elevage/les-:genderSlug(males|femelles)',
        name: 'dogs',
        component: Dogs
    }, {
        path: '*',
        redirect: '/'
    }]
});
